import React from "react";
import SubBanner from "./components/SubBanner";
import Journey from "./components/Journey";
import Mission from "./components/Mission";
import Statistic from "./components/Statistic";
import Team from "./components/Team";
import Update from "./components/Update";
import Follow from "./components/Follow";
import MissionOne from "./components/MissionOne";
import WhyChoose from "./components/WhyChoose";
import YouTubeFollow from "./components/YouTubeFollow";

function About() {
  return (
    <>
      <SubBanner title="About Us"/> 
      <Journey />
      <MissionOne />
      <Mission /> 
      <WhyChoose /> 
      <YouTubeFollow />
               
      
          
    </>
  );
}

export default About;